import React, { Component } from 'react';
import PropTypes from 'prop-types';

import localize from '../../i18n/i18n-hoc';
import { ContainerConsumer } from '../index';

class SessionLoader extends Component {
  constructor(props) {
    super(props);
    const { container } = this.props;

    this.twilio = container.get('TwilioController');
    this.TranslationService = container.get('TranslationService');
    this.features = container.get('Features');
  }

  componentDidMount() {
    if (this.features.chat) {
      this.twilio.initialize();
    }

    if (this.features.localization) {
      this.TranslationService.handleTranslations(this.props);
    }
  }

  render() {
    return this.props.children;
  }
}

SessionLoader.propTypes = {
  container: PropTypes.shape({}),
  children: PropTypes.node,
};

const SessionLoaderWrapped = props => (
  <ContainerConsumer>
    { container => <SessionLoader {...props} container={container} />}
  </ContainerConsumer>
);

export default localize(SessionLoaderWrapped);



// WEBPACK FOOTER //
// ./src/app/components/SessionLoader.js